import { render, staticRenderFns } from "./Pageheader.vue?vue&type=template&id=596c5506&scoped=true&"
import script from "./Pageheader.vue?vue&type=script&lang=js&"
export * from "./Pageheader.vue?vue&type=script&lang=js&"
import style0 from "./Pageheader.vue?vue&type=style&index=0&id=596c5506&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c5506",
  null
  
)

export default component.exports